/****************************************************
 * Module Name:  index.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LicenseInfo } from "@mui/x-license-pro";

LicenseInfo.setLicenseKey(
  "0e50139e1791ee6ca613e48ebd2910d6Tz0xMTI2MTEsRT0xNzc4Mjg0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
